import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import StatsCard from '../../components/shared/StatsCard';
import { mockEquipmentCategoryStats, mockEquipmentStatusDistribution } from '../data/mockData';

const { Text } = Typography;

const EquipmentTab: React.FC = () => {
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} lg={12}>
        <StatsCard
          title="Equipment Categories"
          icon={<ToolOutlined />}
          stats={mockEquipmentCategoryStats}
        />
      </Col>
      <Col xs={24} lg={12}>
        <StatsCard
          title="Equipment Status"
          progress={mockEquipmentStatusDistribution}
        />
      </Col>
      <Col span={24}>
        <Card title="Equipment Utilization Trends" size="small">
          <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text type="secondary">Equipment utilization chart would be displayed here</Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default EquipmentTab; 